import moment from 'moment';

export const HARDCODED_ACTIVE_PROMOS = [
  {
    key: 'referral-bonus',
    enabled: moment().isBetween(
      new Date('2025-04-14T00:00:00.000Z'),
      new Date('2025-10-16T23:59:59.999Z'),
    ),
  },
].filter(({ enabled }) => enabled);

export const isReferralBonusActive = HARDCODED_ACTIVE_PROMOS.some(
  ({ key }) => key === 'referral-bonus',
);
